import { NonRosterUser, RosterParticipant } from '../../../models';
import { isRosterMinor } from '../../desktop-only/group-management/family-groups/family-groups-classification';

export type RemoveFromTripTarget = RosterParticipant | NonRosterUser;

export type RemoveFromTripCopyVariant = 'roster' | 'non-roster';

export function removeFromTripCopyVariant(target: RemoveFromTripTarget): RemoveFromTripCopyVariant {
  return target.type === 'non-roster' ? 'non-roster' : 'roster';
}

export function showsRemoveFromTripFundraisingWarning(variant: RemoveFromTripCopyVariant): boolean {
  return variant === 'roster';
}

/** Minors on this trip whose guardian link will break when the targets are removed. */
export function minorsUnlinkedByRemoveFromTripTargets(
  roster: RosterParticipant[],
  targets: RemoveFromTripTarget[],
): RosterParticipant[] {
  const parentUserIds = new Set(targets.map((target) => target.id));
  if (parentUserIds.size === 0) {
    return [];
  }
  return roster.filter(
    (participant) =>
      isRosterMinor(participant) &&
      participant.newtripUser.parentId != null &&
      parentUserIds.has(participant.newtripUser.parentId),
  );
}
